import styled from "styled-components";
import { IncidentReportsPageStyle } from "@pages/incidentReportsPage/incidentReportsPageStyle";

export const LogisticReportsPageStyle = styled(IncidentReportsPageStyle)`

`;
